module.exports = __webpack_public_path__ + "img/vol-on.f64be2ce.svg";